import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo_payme.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://qr.payme.hsbc.com.hk/2/AztpYiAJBccyCbjgFyRFsM",
    target: "_blank"
  }, "PayMe")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "付款證明", -1)
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { fixed: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_list, { class: "normal-text" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list_header, { color: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentInfo')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createTextVNode("付款後請透過 WhatsApp 將"),
                    _hoisted_3,
                    _createTextVNode("連同訂單編號發送至 "),
                    _createElementVNode("a", {
                      target: "_blank",
                      href: $setup.getWhatsAppLink($props.orderCode)
                    }, _toDisplayString($setup.settings.paymentProofReturnPhoneNumber), 9, _hoisted_4)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}